import { filterChangeCenterSite, processAllData } from '../util';
import { crudRequest, selectByCodes } from '@/services/api';

import { OutletsNextSiteQuery } from '../Tables/OutletsDepartureTable/Sql';
import Queryable from '@/Entity/Tools/Queryable';
import { computeWeightNotAbs } from '@/utils/query';
import { considerZero } from '@/utils/utils';
import {
  exportRepertoryDetail,
  exportTrunkLineArrivalDetail,
  fetchAllData,
  getPlanTime,
} from '@/services/centerweightviewSiteNew';
import { getData_Vehicle } from '@/components/report/service';
import { message } from 'antd';
import moment from 'moment';

// eslint-disable-next-line no-unused-vars
//构建导出目的网点参数集合
const buildDestinationSiteList = (tableItem = [], currentFirstSite) => {
  const destinationSiteMap = new Map();

  tableItem.forEach((item) => {
    const firstSite = item?.firstSite;
    const destinationSite = item?.destinationSite;

    if (!firstSite || !destinationSite) {
      return;
    }

    if (currentFirstSite && firstSite !== currentFirstSite) {
      return;
    }

    if (destinationSiteMap.has(destinationSite)) {
      return;
    }

    destinationSiteMap.set(destinationSite, destinationSite);
  });

  return Array.from(destinationSiteMap.values());
};
//构建导出目的网点参数集合
const buildDestinationSiteListFromAllResult = (allResult = [], currentFirstSite) => {
  const relationSourceList = allResult.slice(0, 6).flat();
  return buildDestinationSiteList(relationSourceList, currentFirstSite);
};
//构建导出目的网点参数集合
function* appendDestinationSiteRelationList(payload, { call, select }) {
  if (payload?.destinationSiteFlag === 1) {
    return payload;
  }

  const relationQuery = {
    startDate: payload?.startDate,
    endDate: payload?.endDate,
    departureCenter: payload?.departureCenter,
    departureCenterCode: payload?.departureCenterCode,
    preSiteFlag: payload?.preSiteFlag,
    destinationSiteFlag: 1,
  };

  const allResult = yield call(fetchAllData, relationQuery);
  const destinationSiteList = buildDestinationSiteListFromAllResult(
    allResult,
    payload?.firstSite,
  );

  return {
    ...payload,
    destinationSiteList,
  };
}

export default {
  namespace: 'centerWeightViewOutletsTablesNew',
  state: {
    tableItem2: [],
    dataListCache: null,
    showDesSite: false,
    showPreSiteFlag: true,
    page: 1,
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      // yield put({ type: 'getPlanDeparture' });
      yield put({ type: 'fetchAllData' });
    },

    *fetchAllData(_, { call, put, select }) {
      let sitePlanParams = yield select(
        ({ centerWeightViewOutletsTablesNew, centerWeightViewSiteNew }) => ({
          preSiteFlag: centerWeightViewOutletsTablesNew.showPreSiteFlag ? 1 : 0,
          destinationSiteFlag: centerWeightViewOutletsTablesNew.showDesSite ? 1 : 0,
          departureCenterCode: centerWeightViewSiteNew.centerFilterCode,
          departureCenter: centerWeightViewSiteNew.centerFilter,
          classityAreaName: centerWeightViewSiteNew.classityAreaName,
          startDate: moment(centerWeightViewSiteNew.dateRange[0]).format(
            centerWeightViewSiteNew.defualtDateFormat,
          ),
          endDate: moment(centerWeightViewSiteNew.dateRange[1]).format('YYYY-MM-DD HH:mm:59'),
        }),
      );
      let volumeItem = yield select(
        ({ centerWeightViewSiteNew }) => centerWeightViewSiteNew.volumeItem,
      );
      const AllResult = yield call(fetchAllData, sitePlanParams);
      const tableItem2 = yield call(processAllData, AllResult, sitePlanParams, volumeItem);
      //找到一级网点和目的网点
      const tableQuery = tableItem2?.map((item) => {
        return {
          firstSite: item?.firstSite,
          destinationSite: item?.destinationSite,
        };
      });
      if (tableQuery?.length > 0) {
        const tableParams = {
          params: tableQuery,
          destinationSiteFlag: sitePlanParams.destinationSiteFlag,
          scanCenterCode: sitePlanParams.departureCenterCode,
          scanCenter: sitePlanParams.departureCenter,
          classityAreaName: sitePlanParams.classityAreaName,
        };
        const planTimeResult = yield call(getPlanTime, tableParams);
        if (planTimeResult && planTimeResult.data?.length > 0) {
          tableItem2.forEach((item) => {
            const result = planTimeResult.data?.find((plan) =>
              !sitePlanParams.destinationSiteFlag
                ? plan.firstSite === item.firstSite
                : plan.destinationSite === item.destinationSite,
            );
            if (result) {
              item.planTime = result.planTime;
            }
          });
        }
      }

      yield put({
        type: 'update',
        payload: {
          dataListCache: [],
          tableItem2: tableItem2,
        },
      });
    },
    *exportTransitDetail({ payload }, { call, select }) {
      const exportPayload = yield* appendDestinationSiteRelationList(payload, { call, select });
      const res = yield call(exportTrunkLineArrivalDetail, exportPayload);

      if (res?.code === 1) {
        message.success('请到导出页面下载');
        return;
      }

      message.warning('中转预到达明细导出失败');
    },
    *exportInStockDetail({ payload }, { call, select }) {
      const exportPayload = yield* appendDestinationSiteRelationList(payload, { call, select });
      const res = yield call(exportRepertoryDetail, exportPayload);

      if (res?.code === 1) {
        message.success('请到导出页面下载');
        return;
      }

      message.warning('在库明细导出失败');
    },
    // 网点预计出发货量
    *getPlanDeparture(_, { call, put, select }) {
      let query = yield select(({ centerWeightViewSiteNew, centerWeightViewOutletsTablesNew }) => {
        return {
          sitePlan: centerWeightViewSiteNew.sitePlan,
          actualDepartureCarsItem: centerWeightViewSiteNew.actualDepartureCarsItem,
          volumeItem: centerWeightViewSiteNew.volumeItem,
          centerFilter: centerWeightViewSiteNew.centerFilter,
          centerFilterCode: centerWeightViewSiteNew.centerFilterCode,
          siteName: centerWeightViewSiteNew.centerFilter.replace('分拨中心', ''),
          startDate: moment(centerWeightViewSiteNew.dateRange[0]).format(
            centerWeightViewSiteNew.defualtDateFormat,
          ),
          endDate: moment(centerWeightViewSiteNew.dateRange[1]).format('YYYY-MM-DD HH:mm:59'),
          showDesSite: centerWeightViewOutletsTablesNew.showDesSite,
          // showPreSiteFlag: centerWeightViewOutletsTablesNew.showPreSiteFlag,
        };
      });
      console.log(`上站已发：${JSON.stringify(query.sitePlan)}`);

      const filter = OutletsNextSiteQuery({
        scanSiteCode: query.centerFilterCode,
        startDate: query.startDate,
        endDate: query.endDate,
        centerFilter: query.centerFilter,
      });
      const result = yield call(getData_Vehicle, filter[0]);
      try {
        if (result?.length > 0) {
          let levelOneSite, centerSite;

          try {
            // 尝试获取站点信息
            ({ levelOneSite, centerSite } = yield* fetchSite());
          } catch (error) {
            console.error('Error fetching site data:', error);
            throw new Error('Failed to fetch site data');
          }

          const siteName = query.centerFilter.replace('分拨中心', '');
          // 网点数据
          const results = [];

          for (let i = 0; i < filter[1].length; i++) {
            try {
              const d = yield call(getData_Vehicle, filter[1][i]);
              const temp = new Map();
              d.map((item) => {
                temp.set(item.destinationSiteCode, item);
              });
              results.push(temp);
            } catch (error) {
              console.error(`Error fetching vehicle data for filter ${i}:`, error);
              results.push(new Map()); // 如果失败，仍然推进一个空 Map
            }
          }

          console.log(
            '%c [ results ]-85',
            'font-size:13px; background:pink; color:#bf2c9f;',
            results,
          );

          result.forEach((item, index) => {
            const firstSite = levelOneSite?.[item.destinationSiteCode]?.firstSite ?? {};
            const { siteName: siteNames = '', isReceive = null, stockBindSite = {} } = firstSite;

            // 检查 centerSite 是否为空
            const center = centerSite?.[item.destinationSiteCode] ?? {};
            const { sendCenterCode = '', sendCenterName = '' } = center;

            // 更新 item 中的站点信息
            item.levelOnSiteName =
              isReceive === 20 && stockBindSite?.siteName ? stockBindSite.siteName : siteNames;

            results.forEach((items, index2) => {
              const calcWeightTotals = items.get(item.destinationSiteCode);
              if (calcWeightTotals) {
                item[`calcWeight${index2}`] = calcWeightTotals.calcWeight || 0;
              }
            });

            //#region 拼接数据
            item.index = index;
            item.site = siteName;
            item.siteName = query.centerFilter;
            item.centerCode = sendCenterCode;
            item.centerName = sendCenterName;

            const calcWeight0 = item.calcWeight0 || 0;
            const calcWeight1 = item.calcWeight1 || 0;
            if (Math.abs(calcWeight0) < Math.abs(calcWeight1)) {
              item.originCalcWeight = 0;
            } else {
              item.originCalcWeight = computeWeightNotAbs(calcWeight0 - calcWeight1);
            }

            const calcWeight2 = item.calcWeight2 || 0;
            const calcWeight3 = item.calcWeight3 || 0;
            if (Math.abs(calcWeight2) < Math.abs(calcWeight3)) {
              item.trainsCalcWeight = 0;
            } else {
              item.trainsCalcWeight = computeWeightNotAbs(calcWeight2 - calcWeight3);
            }

            const calc = (item.calcWeight4 || 0) + (item.calcWeight5 || 0);
            item.unloadedCalcWeight = calc > 0 ? computeWeightNotAbs(calc) : 0;

            const calcPy = (item.calcWeight6 || 0) + (item.calcWeight7 || 0);
            item.superiorityWeight = calcPy > 0 ? computeWeightNotAbs(calcPy) : 0;

            const calcWeight8 = item.calcWeight8 || 0;
            if (calcWeight8) {
              item.dailyCalcWeight = Number(
                (computeWeightNotAbs(calcWeight8) / 7).toFixed(
                  computeWeightNotAbs(calcWeight8 || 0) / 7 > 0.1 ? 1 : 2,
                ),
              );
            } else {
              item.dailyCalcWeight = 0;
            }

            item.setTotal = Number.parseFloat(
              // (item.originCalcWeight || 0) +
              (item.trainsCalcWeight || 0) +
              (item.unloadedCalcWeight || 0),
            ).toFixed(1);
          });
        }
      } catch (error) {
        console.error('Error processing data:', error);
        // 你可以根据需求在这里做进一步的错误处理，比如显示用户友好的错误消息
      }

      const filterResult = filterChangeCenterSite(result, query.centerFilterCode);
      //#region 根据一级网点分组,相同网点的放在一起
      // const dataList = Object.values(groupBys(result, 'levelOnSiteName')).reduce((f, b) => f.concat(b))

      const dataListCache = new Queryable(filterResult).GroupByField('levelOnSiteName');
      const dataList = dataListCache.AggreObject([
        'originCalcWeight',
        'trainsCalcWeight',
        'unloadedCalcWeight',
        'superiorityWeight',
        'setTotal',
        'dailyCalcWeight',
      ]);

      //#endregion
      let dataSource = [];
      try {
        dataSource = query.showDesSite
          ? Object.values(dataListCache).reduce((f, b) => f.concat(b), [])
          : dataList;
        // dataSource = dataSource.filter(item => query.centerFilterCode === item.centerCode);
        dataSource = dataSource.filter(
          (item) =>
            !considerZero(item.originCalcWeight, 0) ||
            !considerZero(item.trainsCalcWeight, 0) ||
            !considerZero(item.unloadedCalcWeight, 0) ||
            query.centerFilterCode === item.centerCode,
        );
        console.log(`tableItem: ${JSON.stringify(dataSource)}`);
      } catch (error) {
        dataSource = [];
      }
      yield put({
        type: 'update',
        payload: {
          dataListCache,
          tableItem2: dataSource,
        },
      });
      /** 获取一级网点 以及 分拨 */
      function* fetchSite() {
        const siteCodes = result.map((item) => item.destinationSiteCode);
        let levelOneSite = {}; // 一级网点
        let centerSite = {}; // 分拨
        const fetchLevelOneSiteCount = 100;
        const promiseAll = [];
        const sitePromiseAll = [];
        for (let i = 0; i < siteCodes.length; i += fetchLevelOneSiteCount) {
          const fetch = crudRequest(
            `/api/station/business/batchSelectDeliverySite`,
            {
              paramType: 'siteCode',
              queryParam: siteCodes.slice(i, i + fetchLevelOneSiteCount),
            },
            { module: 'mdp-station-business' },
          );
          const fetchSites = selectByCodes(siteCodes.slice(i, i + fetchLevelOneSiteCount));
          promiseAll.push(fetch);
          sitePromiseAll.push(fetchSites);
        }
        const levelOneSiteResult = yield Promise.all(promiseAll);
        const sitesResult = yield Promise.all(sitePromiseAll);
        levelOneSiteResult.map((data) => {
          if (data.code === 1) {
            levelOneSite = { ...levelOneSite, ...data.data };
          }
        });
        sitesResult.map((data) => {
          if (data.code === 1) {
            centerSite = { ...centerSite, ...data.data };
          }
        });
        return {
          levelOneSite,
          centerSite,
        };
      }
    },
    // 获取计划离港时间
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
